module.exports = __webpack_public_path__ + "img/blockClient.cc39737e.svg";